module.exports = __webpack_public_path__ + "static/img/2022.3d04bd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/2022.png
// module id = dJ+Z
// module chunks = 44